import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22handbookFonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/playfair-display-latin.woff2%22,%22weight%22:%22400%20900%22,%22style%22:%22normal%22,%22display%22:%22swap%22,%22preload%22:false,%22variable%22:%22--font-family-handbook-serif%22}],%22variableName%22:%22handbookSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'handbookSerif', 'handbookSerif Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
